import { createClient as createKeycloakClient } from '@bifrost/keycloak-client';
import { start } from 'single-spa';
import { registerModule } from '@utils/register_module';
import './index.systemjs';
import './index.styles.scss';
createKeycloakClient({
    url: window.bifrostWeb.keycloak.url,
    realm: window.bifrostWeb.keycloak.realm,
    clientId: window.bifrostWeb.keycloak.clientId,
});
window.bifrostWeb = {
    ...window.bifrostWeb,
    capabilities: [],
    navigate: path => window.history.pushState({}, '', path),
    getIsMobile: () => false,
};
registerModule({ name: 'shared', isAlwaysActive: true });
registerModule({ name: 'portal-navigation', isAlwaysActive: true });
registerModule({ name: 'portal-devices' });
registerModule({ name: 'portal-dashboard' });
registerModule({ name: 'company' });
registerModule({ name: 'portal-updater' });
registerModule({ name: 'portal-media-apps' });
registerModule({ name: 'portal-support' });
registerModule({ name: 'portal-billing' });
registerModule({ name: 'portal-knowledge-base' });
start();
